var jqueryValidation = require('validation');
var formValidation = (function() {

    $.validator.addMethod("newPassword", function(value, element) {
        return this.optional(element) || /^(?=^.{6,}$)(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z]).+$/.test(value);
    }, "Password must have at least one lower case, one upper case, one digit)");

    $.validator.setDefaults({
        errorElement: 'span',
        errorClass: 'error-label',
        errorPlacement: function(error, element) {
            error.insertAfter(element.parent().parent().find('label'));
        },
        highlight: function(element) {
            $(element).closest('.form-group').addClass('has-error');
        },
        unhighlight: function(element) {
            $(element).closest('.form-group').removeClass('has-error').addClass('passed');
        },
        messages: {
            email_address: {
                required: 'Please enter your email address',
                email: 'Does not appear to be a valid email'
            },
            new_email: {
                required: 'Please enter your new email address',
                email: 'Does not appear to be a valid email'
            },
            repeat_new_email: {
                required: 'Please repeat the email',
                equalTo: 'Emails dont seem to match'
            },
            password: {
                required: 'A password is required'
            },
            new_password: {
                required: 'A new password is required',
                newPassword: 'Password does not meet the Requirements'
            },
            repeat_password: {
                required: 'Please repeat the password',
                equalTo: 'Passwords dont seem to match'
            },
            first_name: {
                required: "Your first name is required"
            },
            last_name: {
                required: "Your last name is required"
            },
            card_number: {
                required: "A card number is required",
                number: "Please enter a valid card number"
            },
            name: {
                required: "The cardholder's name is required",
            },
            cvc: {
                required: "The CVC number is required"
            },
            exp_month: {
                required: "Please enter the expiry month"
            },
            exp_year: {
                required: "Please enter the expiry year"
            },
            club_name: {
                required: "Please enter a club name"
            },
            team_name: {
                required: "Please enter the team name"
            },
            phone_number: {
                digits: "Please enter only numbers with no spaces"
            },
        }
    });
})();



// WEBPACK FOOTER //
// ./library/js/plugins/form-validation.js